import DOMPurify from 'dompurify';
import * as React from 'react';
import cn from '../ui/Tailwind';

type WarningType = 'warning' | 'danger' | 'success' | 'info';

type WarningProps = {
  show?: boolean;
  children?: string | React.ReactChild;
  classNames?: string;
  warnings?: Record<string, string>;
  warningKey?: string;
  type?: WarningType;
  icon?: string;
};

const Warning: React.FC<WarningProps> = ({
  show,
  children,
  classNames,
  warnings,
  warningKey,
  type = 'warning',
  icon,
}) => {
  if (warnings && warningKey && warnings[warningKey]) {
    const sanitizedHtmlString = DOMPurify.sanitize(warnings[warningKey]);
    children = <div dangerouslySetInnerHTML={{ __html: sanitizedHtmlString }} />;
  }

  const getIcon = (type: WarningType) => {
    if (icon) return icon;
    switch (type) {
      case 'danger':
        return 'error_outline';
      case 'success':
        return 'check_circle';
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      default:
        return 'warning';
    }
  };

  return (
    <div
      className={cn(
        'mfb-alert',
        type,
        'tw-duration-150',
        { 'tw-opacity-100': show },
        { 'tw-opacity-0': !show },
        classNames,
      )}
      role="alert"
    >
      <i className="material-icons" style={{ fontSize: '1.25rem', marginInlineEnd: '0.5rem' }}>
        {getIcon(type)}
      </i>
      {children}
    </div>
  );
};

export default Warning;
